import request from '../utils/request';

// 平台代售退货信息 API
export const platformSalesReturnApi = {
  // 分页查询平台代售退货信息列表
  // params: { page, size, orderId }
  getPlatformSalesReturnList: (params) => request.get('/platform-sales-return', { params }),
  
  // 获取平台代售退货信息详情
  getPlatformSalesReturnDetail: (id) => request.get(`/platform-sales-return/${id}`),
  
  // 创建平台代售退货信息
  createPlatformSalesReturn: (data) => request.post('/platform-sales-return', data),
  
  // 更新平台代售退货信息
  updatePlatformSalesReturn: (id, data) => request.put(`/platform-sales-return/${id}`, data),
  
  // 删除平台代售退货信息
  deletePlatformSalesReturn: (id) => request.delete(`/platform-sales-return/${id}`),
  
  // 根据订单ID查询退货信息
  getReturnByOrderId: (orderId) => request.get(`/platform-sales-return/order/${orderId}`)
};

